import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  ContextMenuMain,
  ContextMenuSettingsItem,
  ContextMenuNavigationItem,
  ContextMenuSeparator,
  IconSpeechBubble,
  IconClock,
  IconProfile,
  constants
} from 'mage-deps/@klarna/bubble-ui'
import moment from 'moment-timezone'
import { selectors as i18nSelectors } from 'mage-i18n'
import * as R from 'ramda'
import {
  withStyleSheetOverride
} from '@klarna/higher-order-components'

import { selectors as coreSelectors } from 'mage-core'

const GRID_SIZE = constants.Grid.SIZE

const getDefaultStyleSheet = () => ({
  menu: {
    position: 'relative',
    display: 'block',
    top: 2 * GRID_SIZE,
    width: 300
  }
})

export function Menu ({
  isKlarnaRealm,
  t,
  language,
  styleSheet,
  onLanguageClick,
  onLogoutClick,
  onProfileClick
}) {
  return (
    <div id='usermenu-menu' style={styleSheet.menu}>
      <ContextMenuMain>
        <ContextMenuSettingsItem
          id='usermenu-menu-language'
          onClick={onLanguageClick}
          icon={IconSpeechBubble}
          label={t('core.usermenu.language')}
          value={t(`core.languages.${language}`)}
        />

        <ContextMenuSettingsItem
          id='usermenu-menu-tz'
          icon={IconClock}
          label={t('core.usermenu.timezone')}
          value={moment.tz(moment.tz.guess()).format('zZ')}
        />

        {
          !isKlarnaRealm && (
            <ContextMenuSettingsItem
              id='usermenu-menu-profile'
              onClick={onProfileClick}
              icon={IconProfile}
              label={t('core.usermenu.profile')}
              value={t('core.usermenu.changeProfile')}
            />
          )
        }

        <ContextMenuSeparator key='separator' />

        <ContextMenuNavigationItem
          id='usermenu-menu-logout'
          onClick={onLogoutClick}
          label={t('core.usermenu.logout')}
        />
      </ContextMenuMain>
    </div>
  )
}

Menu.propTypes = {
  isKlarnaRealm: PropTypes.bool.isRequired,
  t: PropTypes.func,
  language: PropTypes.string,
  styleSheet: PropTypes.shape({
    menu: PropTypes.object
  }),
  onLanguageClick: PropTypes.func.isRequired,
  onLogoutClick: PropTypes.func.isRequired,
  onProfileClick: PropTypes.func.isRequired
}

export default R.compose(
  withStyleSheetOverride(getDefaultStyleSheet),
  connect(
    (state) => ({
      t: i18nSelectors.translator(state),
      language: i18nSelectors.language(state),
      isKlarnaRealm: coreSelectors.isKlarnaRealm(state)
    })
  )
)(Menu)
